import React from 'react';
import { ButtonSize, ButtonVariant } from "../button";
import { IconCross, IconSize } from "../icons";
import { TEXT_COLOR } from "./constants";
import { StyledButton } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var MessageBannerDismissButton = function MessageBannerDismissButton(_ref) {
  var colorBase = _ref.colorBase,
      iconAltText = _ref.iconAltText,
      setIsVisible = _ref.setIsVisible;
  return ___EmotionJSX(StyledButton, {
    colorBase: colorBase,
    dataTestComponent: "MessageBannerDismissButton",
    icon: ___EmotionJSX(IconCross, {
      color: TEXT_COLOR,
      size: IconSize.ExtraSmall,
      title: iconAltText
    }),
    onClick: function onClick() {
      return setIsVisible(false);
    },
    size: ButtonSize.Small,
    variant: ButtonVariant.Tertiary
  });
};

export default MessageBannerDismissButton;